import React from 'react';
import Brick from './BrickCore';
import { FormsField } from '../../components';
import { Col, FormGroup, Label } from 'reactstrap';

/** Class representing a workflow brick to
 * handle a form submission server side.
 *
 * [server_side]
 */
class FormHandleBrick extends Brick {
    /**
     * @param {{ forms?: object[] }|null|undefined} detailCtx
     * @returns {string|null}
     */
    getNodeDetails(detailCtx) {
        const forms = detailCtx?.forms || [];
        const formId = this.getOption('form_id');
        if (formId == null)
            return null;

        const form = forms.find((f) => String(f?.id) === String(formId) || String(f?._id) === String(formId));
        const label = this.localizedDetailLabel(form?.name, detailCtx, '');
        return label || null;
    }

    /**
     * Get this brick options form
     *
     * @param {Object} props: an object with the following keys
     *                          - t
     *                          - workflow
     *                          - forms
     *                          - emails
     *                          - articles
     *                          - salepoints
     */
    getOptionsForm(props) {
        const { t, forms } = props;

        if (!forms)
            return null;

        return (
            <FormGroup row>
                <Label for="form_id" className="text-v-center" sm={12}>
                    { t('workflows.bricks.form.handle.options.form_id') }
                </Label>
                <Col sm={12}>
                    <FormsField forms={forms} name={`bricks[${this.position}].options.form_id`} single />
                </Col>
            </FormGroup>
        );
    }
}


export default FormHandleBrick;
